import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'
import Checkbox from '@material-ui/core/Checkbox'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import Loading from '../../components/Loading'
import Modal from '@material-ui/core/Modal'
import { motorService } from '../../services/motor.service'
import _ from 'lodash'
import axios from 'axios'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const CustomCheckbox = withStyles({
  checked: {
    color: '#1a63b6',
  },
})(Checkbox)

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  wrapper: {
    padding: '16px',
  },
  betweenWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '24px',
    marginBottom: '8px',
  },
  normalText: {
    ...fontDefault,
    fontSize: '16px',
    color: '#999999',
    marginLeft: '24px',
    marginRight: '24px',
  },
  normalTextSmall: {
    ...fontDefault,
    fontSize: '14px',
    color: '#878b96',
  },
  textArea: {
    ...fontDefault,
    fontSize: '16px',
    padding: '16px',
    maxHeight: '200px',
    border: '1px solid #bcc2d2',
    borderRadius: '5px',
    resize: 'none',
    width: '100%',
    outline: 'none',
    minHeight: '200px',
  },
  blankUploadContainer: {
    height: '100px',
    border: '1px dashed #c3c5cb',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    borderRadius: '4px',
  },
  uploadedContainer: {
    position: 'relative',
    display: 'block',
    height: '100px',
    border: '1px solid #c3c5cb',
    borderRadius: '4px',
  },
  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}

function readFileToUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = event => {
      resolve(event.target.result)
    }
    reader.readAsDataURL(file)
  })
}

async function asyncForEach(array, callback) {
  for (let index = 0; index < (array.length || array.size); index++) {
    await callback(array[index] || array.docs[index], index, array)
  }
}

class SendReport extends Component {
  state = {
    message: '',
    isAttachImage: false,
    attachments: [],
    isLoading: false,
  }

  submit = async () => {
    const { auth } = this.props
    const { attachments, message } = this.state
    const token = _.get(auth, 'token', null)
    this.setState({
      isLoading: true,
    })

    try {
      let uploadData = {}
      if (attachments.length > 0) {
        const file = _.get(attachments, '0.file', undefined)
        const fileType = file.type
        const response = await motorService.postPresignUrl(token, {
          content_type: fileType,
        })
        const signedUrl = _.get(response, 'url', '')
        const uuid = _.get(response, 'uuid', '')
        const options = {
          headers: {
            'Content-Type': fileType,
            'x-amz-acl': 'private',
          },
        }

        const uploadResponse = await axios.put(signedUrl, file, options)
        const uploadedURL = _.get(uploadResponse, 'config.url', '')
        uploadData = {
          uuid,
          url: uploadedURL,
        }
      }
      let submitData = {
        message,
      }
      if (!!uploadData.uuid && !!uploadData.url) {
        submitData.uuid = uploadData.uuid
        submitData.url = uploadData.url
      }
      const submitResponse = await motorService.postSendReport(
        token,
        submitData
      )
      if (submitResponse.success) {
        window.location.replace('ascendmoney://closewebview')
      }
    } catch (error) {
      console.error(error)
      const { showError } = this.props
      showError(error.message)
      debugger
    }
    this.setState({
      isLoading: false,
    })
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    push('/error-payment-timeout')
  }

  selectFiles = async event => {
    const files = Array.from(event.target.files)
    const mapFiles = []
    await asyncForEach(files, async file => {
      const reader = new FileReader()
      const url = await readFileToUrl(file)
      mapFiles.push({
        file: file,
        url: url,
      })
    })
    this.setState({
      attachments: [...this.state.attachments, ...mapFiles],
    })
  }

  render() {
    const { classes, errorCode } = this.props
    const {
      message = '',
      isAttachImage = false,
      attachments = [],
      isLoading = false,
    } = this.state
    return (
      <Wrapper>
        <Body>
          <div className={classes.wrapper}>
            <Typography align="center" className={classes.normalText}>
              {errorCode && 'รายงานรหัสข้อผิดพลาด xxxxx '}
              คำแนะนำของคุณจะช่วยให้เราปรับปรุงและ
              พัฒนาผลิตภัณฑ์ให้ตอบโจทย์ผู้ใช้งานมากยิ่งขึ้น
            </Typography>
            <div className={classes.betweenWrapper}>
              <Typography className={classes.normalTextSmall}>
                ข้อความ
              </Typography>
              <Typography className={classes.normalTextSmall}>
                {message.length}/400
              </Typography>
            </div>
            <textarea
              value={message}
              maxLength={400}
              className={classes.textArea}
              onChange={event => {
                if (event.target.value.length <= 400)
                  this.setState({ message: event.target.value })
              }}
            />
            <div className={classes.checkContainer}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      checked={isAttachImage}
                      onChange={event => {
                        this.setState({ isAttachImage: event.target.checked })
                      }}
                      color="#1a63b6"
                    />
                  }
                  label="ต้องการเพิ่มรูป"
                />
              </FormGroup>
            </div>
            {isAttachImage && (
              <div className={classes.imageContainer}>
                <Grid container spacing={1}>
                  {attachments.map((attachment, index) => {
                    return (
                      <Grid item xs={6} sm={4} md={3}>
                        <div className={classes.uploadedContainer}>
                          <img
                            src={attachment.url}
                            className={classes.previewImage}
                          />
                          <IconButton
                            style={{
                              position: 'absolute',
                              top: '0px',
                              right: '0px',
                            }}
                            onClick={() => {
                              const before = attachments.slice(0, index)
                              const after = attachments.slice(
                                index + 1,
                                attachments.length
                              )
                              this.setState({
                                attachments: [...before, ...after],
                              })
                            }}
                          >
                            <Icon style={{ color: '#999999' }}>cancel</Icon>
                          </IconButton>
                        </div>
                      </Grid>
                    )
                  })}
                  {attachments.length === 0 && (
                    <Grid item xs={6} sm={4} md={3}>
                      <label
                        for="image_uploader"
                        className={classes.blankUploadContainer}
                      >
                        <Icon
                          style={{
                            color: '#555555',
                            display: 'block',
                            marginBottom: '4px',
                          }}
                        >
                          camera_alt
                        </Icon>
                        <Typography className={classes.normalTextSmall}>
                          เพิ่มรูป
                        </Typography>
                      </label>
                    </Grid>
                  )}

                  <input
                    id="image_uploader"
                    type="file"
                    accept="image/*"
                    onChange={this.selectFiles}
                    style={{ display: 'none' }}
                  />
                </Grid>
              </div>
            )}
          </div>
          <Modal styles={{ outline: 0 }} open={isLoading}>
            <Loading />
          </Modal>
        </Body>
        <Footer>
          <SubmitButton onClick={this.submit}>ส่ง</SubmitButton>
        </Footer>
        <Header>
          <TopBar close={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              ส่งรายงานเหตุขัดข้อง
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    errorCode: state.auth.errorCode,
    auth: state.auth,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showError: message => {
      dispatch({
        type: 'ME',
        data: {
          isShowError: true,
          errorMessage: message,
        },
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SendReport))
